import React from "react";

const WhyChooseSection = ({ data }) => (
  <section className="why-choose-section">
    <div className="why-choose-container">
      <h2 className="why-choose-heading">{data.title}</h2>
      <div className="why-choose-grid">
        {data.reasons.map((reason, index) => (
          <div key={`reason-${index}`} className="why-choose-card">
            <span className="check-icon">✔</span>
            <p>{reason}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseSection;
